import React from 'react';
import ReactDOM from 'react-dom';
import geolocationService from "../../services/geolocationService";
import ModalResults from "./ModalResults";
import Loader from "../Loader";
import Pagination from "react-js-pagination";

const API_KEY = process.env.MIX_GOOGLE_MAPS_API_KEY;


class ColetaPolosGeradores extends React.Component {

    prioridades = [
        {value: 2, label: 'Normal'},
        {value: 1, label: 'Alta'}
    ];

    constructor(props) {
        super(props);

        this.inputRef = React.createRef();

        this.state = {
            paginationData: {
                current_page: 0,
                per_page: 10,
                total: 0,
                data: []
            },
            form: {
                cidade: '',
                estado: '',
                endereco: '',
                latitude: '',
                longitude: '',
                cidade_toda: false,
                prioridade: 2 // Baixa por padrão
            },
            loading: false,
            errors: {},
            show_modal_results: false,
            busca_selecionada: null
        }


    }

    salvarNovaColeta = async () => {
        try {
            this.setLoading(true);
            const response = await axios.post(route('web.coleta_polos_geradores.store'), this.state.form);

            if (response.status === 201) {
                await this.setState({
                    ...this.state,
                    form: {
                        cidade: '',
                        estado: '',
                        endereco: '',
                        latitude: '',
                        longitude: '',
                        cidade_toda: false,
                        prioridade: 2 // Reseta para Baixa
                    },
                    paginationData: {
                        ...this.state.paginationData,
                        current_page: 0,
                    }
                });

                this.inputRef.current.value = '';

                await this.loadColetas();
            }

        } catch (error) {
            console.log(error);
            if (error.response && error.response.status === 422) {
                this.setState({
                    errors: error.response.data.errors
                });

            }
        } finally {
            this.setLoading(false);
        }
    }

    onSearchComplete = async (e) => {
        try {
            this.setLoading(true);
            const place = this.autocomplete.getPlaces()[0];

            let latitude = place.geometry.location.lat();
            let longitude = place.geometry.location.lng();

            const cityData = await geolocationService.reverse(latitude, longitude, place);

            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    cidade: cityData.cidade,
                    estado: cityData.uf,
                    endereco: place.formatted_address,
                    latitude: latitude,
                    longitude: longitude
                }
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.setLoading(false);
        }
    }

    componentDidMount = async () => {
        await this.loadColetas();

        if (!window.google) {
            setTimeout(() => {
                this.initAutocomplete();
            }, 1000);
        } else {
            this.initAutocomplete();
        }

    }

    initAutocomplete = () => {
        this.autocomplete = new window.google.maps.places.SearchBox(this.inputRef.current, {
            fields: ['geometry', 'formatted_address'],
            types: ['address'],
        });

        this.autocomplete.addListener('places_changed', this.onSearchComplete);
    }

    componentWillUnmount() {
        this.autocomplete.unbindAll();
    }

    showModalResult = () => {
        this.setState({
            show_modal_results: true
        });
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading
        });
    }

    loadColetas = async (pageNumber = 0) => {
        try {
            this.setLoading(true);

            const url = route('web.coleta_polos_geradores.index-json', {
                page: this.state.paginationData.current_page,
            });

            let response = await axios.get(url);


            this.setState({
                paginationData: response.data
            });

        } catch (error) {
            console.log(error);
        } finally {
            console.log('Finalizou a requisição');
            this.setLoading(false);
        }
    }

    onChangeCidadeToda = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                cidade_toda: e.target.checked
            }
        });
    }


    render() {
        return (
            <div>

                <ModalResults
                    visible={this.state.show_modal_results}
                    onHide={() => this.setState({show_modal_results: false})}
                    busca={this.state.busca_selecionada}
                />


                <div className="card">

                    <div className="card-body">
                        {this.state.loading && <Loader/>}

                        <>

                            <div className="card">
                                <div className="card-body">
                                    <form action="">
                                        <fieldset
                                            style={{border: `1px solid #cccccc`, padding: '20px', borderRadius: '5px'}}>
                                            <legend style={{
                                                fontSize: '1rem',
                                                width: 'auto',
                                                paddingLeft: '5px',
                                                paddingRight: '5px'
                                            }}>Criar Nova Coleta
                                            </legend>
                                            <div className="form-group row">
                                                <div className="col-12 col-sm-6">
                                                    <label htmlFor="nome">Endereço</label>
                                                    <input
                                                        type="text" className="form-control"
                                                        id="endereco" name="endereco"
                                                        ref={this.inputRef}
                                                    />
                                                    {this.state.errors.endereco &&
                                                        <div
                                                            className="invalid-feedback d-flex">{this.state.errors.endereco[0]}</div>}
                                                    {this.state.errors.latitude &&
                                                        <div
                                                            className="invalid-feedback d-flex">{this.state.errors.latitude[0]}</div>}
                                                    {this.state.errors.longitude &&
                                                        <div
                                                            className="invalid-feedback d-flex">{this.state.errors.longitude[0]}</div>}
                                                    {this.state.errors.cidade &&
                                                        <div
                                                            className="invalid-feedback d-flex">{this.state.errors.cidade[0]}</div>}

                                                </div>

                                                <div className="col-12 col-sm-6">
                                                    <label htmlFor="prioridade">Prioridade</label>
                                                    <select className="form-control" value={this.state.prioridade}
                                                            onChange={async(e)=>{
                                                                await this.setState({
                                                                    prioridade : e.target.value,
                                                                });
                                                            }}>
                                                        {this.prioridades.map((prioridade) => {
                                                            return (
                                                                <option key={prioridade.value} value={prioridade.value}>
                                                                    {prioridade.label}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12">
                                                    <label htmlFor="cidade_toda">
                                                        <input
                                                            type="checkbox"
                                                            id="cidade_toda" name="cidade_toda"
                                                            value={this.state.form.cidade_toda}
                                                            checked={this.state.form.cidade_toda}
                                                            onChange={this.onChangeCidadeToda}
                                                        />
                                                        &nbsp; Cidade Toda
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-12 col-sm-6">
                                                    <button type="button" className="btn btn-success btn-sm btn-block"
                                                            onClick={this.salvarNovaColeta}>Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>

                            <hr/>

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr style={{
                                            backgroundColor: 'green',
                                            color: '#333',
                                            fontWeight: 'bold',
                                        }}>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Status</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Cidade</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Estado</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Endereço</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Latitude</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Longitude</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Cidade Toda</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Solicitante</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Data de Criação</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Prioridade</th>
                                            <th style={{fontWeight: 'bold', color: 'white'}}>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.paginationData?.data?.map((coleta, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    {['Pendente', 'Enviado'].includes(coleta.status) && <>
                                                        <span className="badge badge-danger">{coleta.status}</span>
                                                    </>}

                                                    {coleta.status === 'Coletando' && <>
                                                        <span className="badge badge-warning">{coleta.status}</span>
                                                    </>}

                                                    {coleta.status === 'Concluído' && <>
                                                        <span className="badge badge-success">{coleta.status}</span>
                                                    </>}

                                                </td>
                                                <td>{coleta.cidade}</td>
                                                <td>{coleta.estado}</td>
                                                <td>{coleta.endereco}</td>
                                                <td>{coleta.latitude}</td>
                                                <td>{coleta.longitude}</td>
                                                <td>
                                                    {coleta.executar_cidade && <>
                                                        <span className="badge badge-success">Sim</span>
                                                    </>}

                                                    {!coleta.executar_cidade && <>
                                                        <span className="badge badge-danger">Não</span>
                                                    </>}


                                                </td>
                                                <td>{coleta.user?.name}</td>
                                                <td>{coleta.created_at_formatted}</td>

                                                <td>
                                                    {coleta.prioridade === 1 &&
                                                        <span className="badge badge-success">Alta</span>}
                                                    {coleta.prioridade === 2 &&
                                                        <span className="badge badge-secondary">Normal</span>}
                                                </td>

                                                <td>
                                                    <a href="#"
                                                       title="Ver Resultados"
                                                       onClick={(e) => {
                                                           e.preventDefault();
                                                           this.showModalResult();
                                                           this.setState({
                                                               busca_selecionada: coleta
                                                           });
                                                       }}>
                                                        <i className="fa fa-list"></i>

                                                    </a>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    </tbody>
                                </table>

                                <hr/>
                                <div className="d-flex justify-content-center">
                                    <Pagination
                                        activePage={this.state.paginationData.current_page}
                                        itemsCountPerPage={this.state.paginationData.per_page}
                                        totalItemsCount={this.state.paginationData.total}
                                        pageRangeDisplayed={10}
                                        onChange={async (e) => {
                                            await this.setState({
                                                paginationData: {
                                                    ...this.state.paginationData,
                                                    current_page: e
                                                }
                                            });

                                            await this.loadColetas();
                                        }}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('app-coleta-polos-geradores')) {
    ReactDOM.render(<ColetaPolosGeradores/>, document.getElementById('app-coleta-polos-geradores'));
}
